/*
 * Main and demo navigation arrays
 */

export default {
    'main': [{
            name: 'Productos',
            to: '/inicio',
            icon: 'si si-speedometer'
        },
        {
            name: 'Agregar Usuario',
            to: '/usuarionuevo',
            icon: 'si si-speedometer'
        },
        {
            name: 'Lista de usuarios',
            to: '/lista',
            icon: 'si si-speedometer'
        },

    ]
}